export default "__VITE_ASSET__D3VoGcbC__ 160w";